import cn from './column.module.css';

interface ColumnHeadProps {
  title: string;
}

const ColumnHead = ({ title }: ColumnHeadProps) => (
  <div className={cn.columnTop}>
    <p className={cn.columnTitle}>{title}</p>
  </div>
);

export default ColumnHead;
